//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api";//Added 2024-04-18 for refreshToken


class MessageDataService {

  getAll(data) {
    //return axios.get(process.env.VUE_APP_ROOT_API + "message", { headers: authHeader(), params: data }); //Replaced 2024-04-18 due to RefreshToken
    return api.get("message", { params: data });
  }

  get(id) {
    //return axios.get(process.env.VUE_APP_ROOT_API + `message/${id}`, { headers: authHeader()}); //Replaced 2024-04-18 due to RefreshToken
    return api.get(`message/${id}`);
  }

  create(data) {
    //return axios.post(process.env.VUE_APP_ROOT_API + `message`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.post(`message`, data);
  }

  update(id, data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + `message/${id}`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.put(`message/${id}`, data);
  }

/*  delete(id) {
    return axios.delete(process.env.VUE_APP_ROOT_API + `message/${id}`, { headers: authHeader() });
  }*/
}

export default new MessageDataService();